import SmallCoffeeSVG from '../../assets/caffeine-products/small-coffee.svg?react'
import CoffeeSVG from '../../assets/caffeine-products/coffee.svg?react'
import TeaSVG from '../../assets/caffeine-products/tea.svg?react'
import IceTeaSVG from '../../assets/caffeine-products/ice-tea.svg?react'
import EnergyDrinkSVG from '../../assets/caffeine-products/energy-drink.svg?react'
import JarSVG from '../../assets/caffeine-products/jar.svg?react'
import ChocolateBarSVG from '../../assets/caffeine-products/chocolate-bar.svg?react'
import NoneSVG from '../../assets/caffeine-products/none.svg?react'

const selectImgByCaffeineOption = {
  'small-coffee': <SmallCoffeeSVG />,
  coffee: <CoffeeSVG />,
  tea: <TeaSVG />,
  'ice-tea': <IceTeaSVG />,
  'energy-drink': <EnergyDrinkSVG />,
  jar: <JarSVG />,
  'chocolate-bar': <ChocolateBarSVG />,
  none: <NoneSVG />,
  default: <SmallCoffeeSVG />,
}

const CaffeineOptions = ({ tag }) => {
  return selectImgByCaffeineOption[tag] || <SmallCoffeeSVG />
}

export default CaffeineOptions
